import { GlyphType } from 'shared/components/Icon';
import {
  PageDataType,
  QuestionTypeVariantType,
  RangeLabelType,
} from 'shared/types';

export const resolvePlaceholders = ({
  placeholders,
  text,
}: {
  text: string;
  placeholders: Record<string, string>;
}) => {
  if (text) {
    const pattern = new RegExp(Object.keys(placeholders).join('|'), 'gi');
    text = text?.replace(
      pattern,
      (matched) => placeholders[matched.toLowerCase()],
    );
  }
  return text;
};

export const getOrderedPageData = (pageData, surveyInfo) =>
  (pageData || [])
    ?.map?.((page) => {
      if (!page?.order) {
        const foundPage = surveyInfo?.pages?.find(
          (p) => p.page_id === page.page_id,
        );
        return {
          ...page,
          order: foundPage?.order,
        } as PageDataType;
      }
    })
    .sort((a, b) => {
      if (a?.order && b?.order) {
        return a.order - b.order;
      }
      return 0;
    }) || [];

export type IconNameType =
  | 'thumbs-up'
  | 'thumbs-down'
  | 'tick-yes'
  | 'tick-no'
  | 'emoji-yes'
  | 'emoji-no';

export const getRatingIcon = (
  typeVariant: QuestionTypeVariantType,
  ratingGroup: RangeLabelType,
) => {
  let iconName: GlyphType;
  if (typeVariant === 'TICK') {
    iconName =
      ratingGroup === 'promoter' || ratingGroup === 'positive'
        ? 'tick-yes'
        : 'tick-no';
  } else if (typeVariant === 'EMOJI') {
    iconName =
      ratingGroup === 'promoter' || ratingGroup === 'positive'
        ? 'emoji-yes'
        : 'emoji-no';
  } else {
    iconName =
      ratingGroup === 'promoter' || ratingGroup === 'positive'
        ? 'thumbs-up'
        : 'thumbs-down';
  }
  return iconName;
};
